module.exports = __webpack_public_path__ + "static/img/warning.23601066.svg";